import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import AppSpinner from '../../common/components/AppSpinner';
import SkeletonLoader from '../../executive-summary/components/SkeletonLoader';
import ExecutiveStore from '../../executive-summary/stores/executive-store';
import ScanStore from '../../new-scan/store/scan-store';
import SupplyChain from '../components/SupplyChain';

const SupplyChainContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { isScanning } = useSnapshot(ScanStore);
  const { supplyChainItems, supplyChainLoading } = useSnapshot(ExecutiveStore);
  const isLoading =
    supplyChainLoading.isPending() || (isScanning && !supplyChainItems?.length);
  const loadingMessage = supplyChainLoading.isPending()
    ? 'Loading supply chain...'
    : 'Scanning...';
  const hasData = supplyChainLoading.isSuccess() && supplyChainItems?.length;
  const noData =
    (supplyChainLoading.isSuccess() || supplyChainLoading.isError()) &&
    !supplyChainItems?.length;

  return (
    <Box height='100%' display='flex' flexDirection='column'>
      <SkeletonLoader loading={isLoading} message={loadingMessage}>
        <Typography
          variant='body1'
          color='text.secondary'
          fontWeight={600}
          data-testid='software-supply-chain-PBOM'>
          Software Supply Chain PBOM
        </Typography>
        <Box flexGrow={1} position='relative' mt={1}>
          {hasData && <SupplyChain items={supplyChainItems} />}
          {isLoading && <AppSpinner>Loading</AppSpinner>}
          {noData && (
            <Typography color='error' variant='body2'>
              No data found.
            </Typography>
          )}
        </Box>
      </SkeletonLoader>
    </Box>
  );
};

export default SupplyChainContainer;
